const DataExportsQueryKeys = {
  global: ["dataExports"] as const,
  exports: () => [...DataExportsQueryKeys.global, "exports"],
  download: (id: string) =>
    [...DataExportsQueryKeys.global, id, "download"] as const,
};

export { DataExportsQueryKeys };
